<template>
  <m-form
      :title="(isDialog)?null:title"
      :items="items"
      :cols="cols"
      :canSubmit="canSubmit"
      :canDelete="canDeleteAccount"
      :show-clear-btn="isDialog"
      :is-editing.sync="isEditing"
      list-export-base-url="reports/lists/accounts"
      :list_filters="{level: level, account_type: accountType}"
      :exportParams="{id: item.id}"
      :show-creation-data="false"
      :showListBtn="false"
      :show-navigation-btns="false"
      :showList="usage != 'tree'"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="checkFormAndSubmit(item)"
      @delete="deleteItem"
      :can-edit="canEdit"
  >
    <template #header-btns v-if="!isDialog">
      <template v-if="item.id != undefined">
        <v-btn
            depressed
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="openLedger(item)"
        >گردش این حساب
        </v-btn>
      </template>

      <template v-for="i in 4" v-if="!isBank && !isPerson">
        <v-btn
            depressed
            :key="i"
            v-if="i - 1 != level"
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/${i - 1}`"
        >
          {{ getLevelTitle(i - 1) }}
        </v-btn>
        <v-btn
            depressed
            :key="i"
            v-else
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          {{ getLevelTitle(i - 1) }}
        </v-btn>
      </template>
      <template v-if="isBank && !isPerson">
        <v-btn
            depressed
            v-if="accountType != 'b'"
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/b`"
        >
          بانک
        </v-btn>
        <v-btn
            v-if="accountType == 'b'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          بانک
        </v-btn>
        <v-btn
            depressed
            v-if="accountType != 's'"
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/s`"
        >
          کارتخوان
        </v-btn>
        <v-btn
            v-if="accountType == 's'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          کارتخوان
        </v-btn>

        <v-btn
            v-if="accountType != 'g'"
            depressed
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/g`"
        >
          درگاه بانکی
        </v-btn>
        <v-btn
            v-if="accountType == 'g'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          درگاه بانکی
        </v-btn>
        <v-btn
            v-if="accountType != 'd'"
            depressed
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/d`"
        >
          صندوق
        </v-btn>
        <v-btn
            v-if="accountType == 'd'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          صندوق
        </v-btn>
        <v-btn
            v-if="accountType != 'i'"
            depressed
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/i`"
        >
          تنخواه گردان
        </v-btn>
        <v-btn
            v-if="accountType == 'i'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          تنخواه گردان
        </v-btn>
      </template>
      <template v-if="isPerson">
        <v-btn
            v-if="accountType != 'p'"
            depressed
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/p`"
        >اشخاص
        </v-btn>
        <v-btn
            v-if="accountType == 'p'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >اشخاص
        </v-btn>
        <v-btn
            v-if="accountType != 'r'"
            depressed
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/r`"
        >
          جاری شرکا دریافنتی
        </v-btn>
        <v-btn
            v-if="accountType == 'r'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          جاری شرکا دریافنتی
        </v-btn>
        <v-btn
            v-if="accountType != 'a'"
            depressed
            class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0"
            :to="`/panel/accounts/3/a`"
        >
          جاری شرکا پرداختنی
        </v-btn>
        <v-btn
            v-if="accountType == 'a'"
            depressed
            class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"
            @click="clearForm"
        >
          جاری شرکا پرداختنی
        </v-btn>
      </template>
    </template>
    <template #default>
      <v-row>
        <template v-if="hasParent">
          <v-col cols="12">
            <account-select
                v-if="level == 1"
                :label="' * ' + parentTitle"
                :itemsType="itemsType"
                v-model="item.parent"
                :disabled="item.id != undefined || !isEditing"
            />
            <account-select
                v-if="level != 1"
                :label="' * ' + parentTitle"
                :itemsType="itemsType"
                v-model="item.parent"
                :disabled="item.id != undefined || !isEditing"
                @input="
                (parent) => !item.id && parent && (item.type = parent.type)
              "
            />
          </v-col>
          <v-col cols="12" v-if="parents.length">
            <v-breadcrumbs :items="parents">
              <template v-slot:divider>
                <v-icon>fa-chevron-left</v-icon>
              </template>
            </v-breadcrumbs>
          </v-col>
        </template>
        <v-col cols="12" v-if="!isPerson && !isBank && level != 0">
          <v-autocomplete
              class="rounded-lg"
              label="نوع"
              :items="accountTypes"
              v-model="item.type"
              :disabled="!isEditing"
              item-text="name"
              item-value="id"
          />
        </v-col>
        <v-col cols="12" v-if="item.id != undefined">
          <v-text-field
              class="rounded-lg"
              label="کد"
              v-model="item.code"
              disabled
          />
        </v-col>

        <v-col :cols="12" v-if="!isPerson">
          <div id="account-form-name">
            <v-text-field
                label=" * نام"
                v-model="item.name"
                :disabled="!isEditing || !item.is_editable"
                class="rounded-lg"
            />
          </div>
        </v-col>

        <template v-if="isPerson">
          <v-col cols="12" :md="(isPartner)?12:4">
            <div id="account-form-person-type">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  :items="personTypes"
                  v-model="item.person_type"
                  :disabled="item.id != undefined"
                  label=" * نوع شخص"
                  item-text="title"
                  item-value="id"
              ></v-select>
            </div>
          </v-col>
          <v-col cols="12" md="4" v-if="!isPartner">
            <div id="account-form-buyer-or-seller">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  :items="[
                { text: 'خریدار', value: 'b' },
                { text: 'فروشنده', value: 's' },
              ]"
                  v-model="item.buyer_or_seller"
                  item-text="text"
                  item-value="value"
                  :return-object="false"
                  label=" * حساب شخص"
                  required
                  :disabled="item.id != undefined"
              ></v-select>
            </div>
          </v-col>
          <v-col cols="12" md="4" v-if="!isPartner">
            <div id="account-form-buyer-or-seller">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  :items="[
                { text: 'تجاری', value: true },
                { text: 'غیر تجاری', value: false },
              ]"
                  v-model="item.is_commercial"
                  item-text="text"
                  item-value="value"
                  :return-object="false"
                  label=" تجاری"
                  required
                  :disabled="!isEditing"
              ></v-select>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div id="account-form-person-first-name">
              <v-text-field
                  v-if="accountType=='p'"
                  :label="item.person_type != 'l' ? ' نام ' : 'نام  مدیر عامل'"
                  v-model="item.first_name"
                  :disabled="!isEditing || !item.is_editable"
                  class="rounded-lg"
              />
              <v-text-field
                  v-else
                  label="نام"
                  v-model="item.name"
                  :disabled="!isEditing || !item.is_editable"
                  class="rounded-lg"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6" v-if="!isPartner">
            <div id="account-form-person-last-name">
              <v-text-field
                  :label="item.person_type != 'l' ? ' نام خانوادگی' : 'نام خانوادگی مدیر عامل'"
                  v-model="item.last_name"
                  :disabled="!isEditing || !item.is_editable"
                  class="rounded-lg"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6" v-if="!isPartner">
            <div id="account-form-person-name">
              <v-text-field
                  label=" * نام کسب و کار"
                  v-model="item.name"
                  :disabled="!isEditing || !item.is_editable"
                  class="rounded-lg"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6" v-if="!isPartner && item.person_type == 'r' && item.person_type">
            <div id="account-form-tax-type">
              <v-autocomplete
                  class="rounded-lg"
                  label="* نوع پرونده مالیاتی"
                  :items="TAX_TYPES"
                  item-text="text"
                  :disabled="!isEditing"
                  item-value="value"
                  v-model="item.tax_type"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6" v-if="isPerson">
            <v-text-field
                class="rounded-lg"
                v-if="item.person_type == 'l'"
                label="* شناسه ملی"
                v-model="item.melli_code"
                :disabled="!isEditing"
                :hide-details="false"
                :rules="shenaseMeliRules"
            />
            <v-text-field
                :rules="[
              rules.max_non_iranian_national_code,
              rules.min_non_iranian_national_code,
            ]"
                class="rounded-lg"
                v-else-if="item.person_type == 'r' && item.tax_type == '3'"
                label="* کد فراگیر اتباع غیر ایرانی"
                v-model="item.melli_code"

                :disabled="!isEditing"
            />
            <m-national-code
                v-else
                label="کد ملی"
                v-model="item.melli_code"
                :disabled="!isEditing"
                :is-required="false"
            />
          </v-col>
          <v-col cols="12" md="6" v-if="!isPartner && item.person_type != 'l' && item.person_type">
            <div id="account-form-eghtesadi-code">
              <v-text-field
                  class="rounded-lg"
                  label="کد اقتصادی"
                  v-model="item.eghtesadi_code"
                  :disabled="!isEditing"
              />
            </div>
          </v-col>
        </template>

        <v-col cols="12" md="6" v-if="accountType == 's'">
          <div id="account-form-acceptor-company-name">
            <v-text-field
                label=" * نام شرکت پذیرنده"
                v-model="item.acceptor_company_name"
                :disabled="!isEditing"
                class="rounded-lg"
            />
          </div>
        </v-col>
        <v-col cols="12" md="6" v-if="accountType == 's'">
          <div id="account-form-phone-1">
            <v-text-field
                label=" * شماره تماس پشتیبانی"
                v-model="item.phone_1"
                :disabled="!isEditing"
                class="rounded-lg"
            />
          </div>
        </v-col>
        <v-col
            cols="12"
            class="rounded-lg"
            v-if="item.id != undefined && item.balance"
        >
          <v-simple-table>
            <thead>
            <tr>
              <th>بدهکار</th>
              <th>بستانکار</th>
              <th>مانده</th>
              <th>تشخیص</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ item.balance.bed | toMoney }}</td>
              <td>{{ item.balance.bes | toMoney }}</td>
              <td>{{ item.balance.remain | toMoney }}</td>
              <td>{{ getRemainType() }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <template v-if="hasDetail">
          <v-row id="account-form-float-accounts" class="pa-3">
            <v-col
                v-if="hasFeature('FLOAT_ACCOUNTS')"
                v-for="floatAccountType in floatAccountTypes"
                cols="12"
                md="6"
                :key="floatAccountType.groupKey"
            >
              <v-autocomplete
                  class="rounded-lg"
                  v-model="item[floatAccountType.groupKey]"
                  :disabled="!isEditing || item.has_turnover"
                  :clearable="true"
                  :multiple="true"
                  :label="floatAccountType.text"
                  :items="
                floatAccountGroups.filter(
                  (o) => o.type == floatAccountType.type
                )
              "
                  item-text="name"
                  item-value="id"
              />
            </v-col>
          </v-row>
          <v-col cols="12" md="6">
            <div id="account-form-max-bed">
              <money
                  label="سقف بدهکاری"
                  class="form-control"
                  v-model="item.max_bed"
                  :disabled="!isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div id="account-form-max-bes">
              <money
                  label="سقف بستانکاری"
                  class="form-control"
                  v-model="item.max_bes"
                  :disabled="!isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12">
            <v-textarea
                class="rounded-lg"
                rows="2"
                label="توضیحات"
                v-model="item.explanation"
                :disabled="!isEditing"
            />
          </v-col>
        </template>

        <template v-if="isBank && accountType != 'd'">
          <v-col cols="12" md="6">
            <v-autocomplete
                class="rounded-lg"
                :rules="[rules.required]"
                label="نام بانک"
                :items="BANK_NAMES"
                v-model="item.bank_name"
                item-text="name"
                item-value="name"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                label="شماره حساب"
                class="form-control rounded-lg"
                v-model="item.account_number"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                class="rounded-lg"
                label="نام شعبه"
                v-model="item.branch_name"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                class="rounded-lg"
                label="کد شعبه"
                v-model="item.branch_code"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="شماره تماس"
                class="form-control rounded-lg"
                v-model="item.phone"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="6">
            <cart
                :rules="[rules.max_sheba, rules.min_sheba]"
                v-on:keypress="BankNumbersTo24Only"
                ref="bank_sheba"
                label="کد شبا"
                v-model="item.sheba"
                :disabled="!isEditing"
                append-icon="IR"
            >
            </cart>
          </v-col>
          <v-col cols="12" md="6">
            <cart
                :rules="[rules.max_cart, rules.min_cart]"
                v-on:keypress="NumbersTo16Only"
                ref="cart"
                label="شماره کارت "
                v-model="item.account_number_1"
                :disabled="!isEditing"
            >
            </cart>
          </v-col>
        </template>

        <template v-if="isPerson">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" md="4" v-if="!isPartner">
            <v-autocomplete
                :menu-props="{ bottom: true, offsetY: true }"
                class="rounded-lg"
                label="نرخ پیشفرض فروش"
                :items="salePriceTypes"
                v-model="item.defaultSalePriceType"
                :return-object="false"
                item-text="name"
                item-value="id"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                class="rounded-lg"
                label="موبایل"
                v-model="item.mobile"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="accountType == 'p'">
            <v-text-field
                class="rounded-lg"
                label="شماره تماس"
                v-model="item.phone_1"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="8" v-else>
            <v-row>
              <v-col>
                <v-text-field
                    class="rounded-lg"
                    label="شماره تماس 1"
                    v-model="item.phone_1"
                    :disabled="!isEditing"
                />
              </v-col>
              <v-col>
                <v-text-field
                    class="rounded-lg"
                    label="شماره تماس 2"
                    v-model="item.phone_2"
                    :disabled="!isEditing"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                class="rounded-lg"
                label="ایمیل"
                v-model="item.email"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
                class="rounded-lg"
                label=" استان "
                :items="CITY_LIST"
                v-model="item.province"
                item-text="code"
                item-value="code"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
                class="rounded-lg"
                label=" شهر "
                :items="CITY_LIST"
                v-model="item.city"
                item-text="code"
                item-value="code"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                class="rounded-lg"
                label="کد پستی"
                v-model="item.postal_code"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="8" v-if="isPerson">
            <v-textarea
                class="rounded-lg"
                label="آدرس"
                v-model="item.address_1"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="!isPerson">
            <v-text-field
                class="rounded-lg"
                label="فکس"
                v-model="item.fax"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="accountType != 'p' && !isPerson">
            <v-text-field class="rounded-lg" label="وبسایت" v-model="item.website" :disabled="!isEditing"/>
          </v-col>
          <v-col cols="12" md="4" v-if="isPerson">
            <v-text-field
                class="rounded-lg"
                label='شماره حساب'
                v-model="item.account_number_1"
                :disabled="!isEditing"
            />
          </v-col>

          <v-col cols="12" v-else>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                    class="rounded-lg"
                    label="شماره حساب 1"
                    v-model="item.account_number_1"
                    :disabled="!isEditing"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                    class="rounded-lg"
                    label="شماره حساب 2"
                    v-model="item.account_number_2"
                    :disabled="!isEditing"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4">
            <cart
                :rules="[rules.max_sheba, rules.min_sheba]"
                v-on:keypress="NumbersTo24Only"
                ref="sheba"
                label="شماره شبا"
                v-model="item.sheba"
                :disabled="!isEditing"
                append-icon="IR"
            >
            </cart>
          </v-col>
          <v-col cols="12" md="4">
            <cart
                :rules="[rules.max_cart, rules.min_cart]"
                v-on:keypress="NumbersTo16Only"
                ref="cart"
                label="شماره کارت "
                v-model="item.account_number"
                :disabled="!isEditing"
            >
            </cart>
          </v-col>
          <v-col cols="12" md="6" v-if="!isPerson">
            <v-textarea
                class="rounded-lg"
                rows="2"
                label="آدرس 1"
                v-model="item.address_1"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="6" v-if="!isPerson">
            <v-textarea
                class="rounded-lg"
                rows="2"
                label="آدرس 2"
                v-model="item.address_2"
                :disabled="!isEditing"
            />
          </v-col>
          <template v-if="!isPartner && hasModule('distribution')">
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-card-subtitle class="py-0">مسیر</v-card-subtitle>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col v-for="(n, i) in 5" :key="i">
                  <v-autocomplete
                      :menu-props="{ bottom: true, offsetY: true }"
                      class="rounded-lg"
                      v-if="i == 0 || path[i - 1] != undefined"
                      :label="getPathTitle(i)"
                      :items="getPathItems(i)"
                      v-model="path[i]"
                      @input="clearPath(i)"
                      item-text="name"
                      item-value="id"
                      :disabled="!isEditing"
                  />
                </v-col>
              </v-row>
            </v-col>
          </template>
        </template>

        <template
            v-if="
            isBank ||
            accountType == 'p' ||
            accountType == 'a' ||
            accountType == 'r'
          "
        >
          <v-col md="6">
            <div id="account-form-show-in-receive-transaction-switch">
              <v-switch
                  v-model="item.show_in_receive_transaction"
                  label="استفاده در دریافت"
                  :disabled="!isEditing"
                  inset
              ></v-switch>
            </div>
          </v-col>
          <v-col md="6">
            <div id="account-form-show-in-payment-transaction-switch">
              <v-switch
                  v-model="item.show_in_payment_transaction"
                  label="استفاده در پرداخت"
                  :disabled="!isEditing"
                  inset
              ></v-switch>
            </div>
          </v-col>
        </template>
      </v-row>
      <v-row class="mt-2">
        <v-col md="6">
          <div id="account-is_active-switch">
            <v-switch
                v-model="item.is_active"
                label="حساب فعال"
                :disabled="!isEditing"
                inset
            ></v-switch>
          </div>
        </v-col>
      </v-row>

    </template>
  </m-form>
</template>
<script>
import AccountApiMixin from "@/mixin/accountMixin";
import wareApiMixin from "@/mixin/wareApi";
import {MFormMixin} from "@/components/m-form";
import {PathLevels, getText} from "@/variables";
import cityList from "./citys.json";
import cart from "@/components/scomponents/Cart";

export default {
  mixins: [
    MFormMixin,
    AccountApiMixin,
    AccountApiMixin,
    wareApiMixin,
  ],
  components: {cart},
  props: {
    level: {
      requried: true,
    },
    accountType: {
      default: "o",
    },
    parent: {
      default: null,
    },
    usage: {
      default: null,
    },
    isDialog: {
      default: false,
    },
    disableEdit: {
      default: false,
    },
  },
  data() {
    return {
      BANK_NAMES: [
        {name: " آینده", value: "BAYAN"},
        {name: "استاندارد چارترد", value: "CHART"},
        {name: " اقتصاد نوین", value: "BEGHTE"},
        {name: " ایران زمین ", value: "ZAMIN"},
        {name: " پارسیان", value: "BPARSI"},
        {name: " پاسارگاد", value: "BPASAR"},
        {name: "پست بانک ", value: "BPOST"},
        {name: " توسعه صادرات  ایران", value: "BEDIRA"},
        {name: " تجارت ", value: "BTEJAR"},
        {name: " تجاری ایران و اروپا", value: "EURO"},
        {name: "تعاون اسلامی برای سرمایه‌گذاری", value: "ESLA"},
        {name: " توسعه تعاون", value: "BCDEVE"},
        {name: " خاورمیانه ", value: "KHAVA"},
        {name: " دی", value: "BDAY"},
        {name: " رفاه کارگران ", value: "BREFAH"},
        {name: " سامان ", value: "BSAMAN"},
        {name: " سرمایه ", value: "BSARMA"},
        {name: " سپه ", value: "BSEPAH"},
        {name: " سینا ", value: "BSINA"},
        {name: " شهر", value: "BCITY"},
        {name: " صنعت و معدن ", value: "BINDMI"},
        {name: " صادرات ", value: "BSADER"},
        {name: "فیوچر بانک (المستقبل)", value: "FUTU"},
        {name: " قرض الحسنه رسالت ", value: "BRESALA"},
        {name: " قرض الحسنه مهر ایران", value: "BGHARZ"},
        {name: " کارآفرین", value: "BKARAF"},
        {name: " کشاورزی", value: "BKESHA"},
        {name: " گردشگری ", value: "BTOURI"},
        {name: " مسکن", value: "BMASKA"},
        {name: " ملت", value: "BMELLA"},
        {name: "  ملی ایران", value: "BMELLI"},
        {name: " مشترک ایران - ونزوئلا ", value: "VENE"},
        {name: "مؤسسه اعتباری غیربانکی کاسپین ", value: "CASP"},
        {name: "مؤسسه اعتباری غیربانکی  توسعه ", value: "TOSE"},
        {name: "مؤسسه اعتباری غیربانکی  ملل ", value: "MELAL"},
        {name: "مؤسسه اعتباری غیربانکی نور ", value: "NOR"},
      ],

      CITY_LIST: cityList,
      item: {},
      baseUrl: "accounts/accounts",
      personTypes: [
        {
          title: "حقیقی",
          id: "r",
        },
        {
          title: "حقوقی",
          id: "l",
        },
      ],
      cols: [
        {
          text: "کد حساب",
          value: "code",
        },
        {
          text: "نام حساب",
          value: "name",
        },
        {
          text: "نوع",
          value: "type.name",
        },
      ],
      fetchedItems: [],
      path: [null, null, null, null, null],
      TAX_TYPES: [
        {text: "انفرادی", value: "1"},
        {text: "مشارکت", value: "2"},
        {text: "اتباع غیر ایرانی", value: "3"},
      ],
    };
  },
  computed: {
    rules() {
      return {
        max_cart: (v) => v.length <= 19 || "Max 19 characters",
        max_sheba: (v) => v.length <= 29 || "Max 29 characters",
        max_non_iranian_national_code: (v) =>
            v.length <= 12 || "Max 12 characters",
        min_cart: (v) => v.length >= 19 || "Min 19 characters",
        min_sheba: (v) => v.length >= 29 || "Min 29 characters",
        min_non_iranian_national_code: (v) =>
            v.length >= 12 || "Min 12 characters",
      };
    },
    title() {
      const title = this.getTitle(this.level, this.accountType);
      this.setDocumentTitle(title)
      return title
    },
    permissionBasename() {
      return `account${this.level}`;
    },
    parentTitle() {
      return this.getLevelTitle(this.level - 1);
    },
    itemsType() {
      return "level" + (this.level - 1);
    },
    hasParent() {
      return this.level != 0 && !this.isBank && !this.isPerson;
    },
    hasDetail() {
      return this.level == 3;
    },
    isBank() {
      return (
          this.accountType == "b" ||
          this.accountType == "s" ||
          this.accountType == "g" ||
          this.accountType == "d" ||
          this.accountType == "i"
      );
    },
    isPerson() {
      return (
          this.accountType == "p" ||
          this.accountType == "a" ||
          this.accountType == "r"
      );
    },
    isPartner() {
      return this.accountType == "a" || this.accountType == "r";
    },
    items() {
      return this.accounts.filter(
          (o) => o.level == this.level && o.account_type == this.accountType
      );
    },
    parentItems() {
      return this.accountsSelectValues.levels[this.level - 1];
    },
    canClear() {
      return this.isPerson || this.isBank;
    },
    canEdit() {
      if (this.disableEdit) {
        return false
      } else if (this.accountType == 0) {
        if (this.hasFeature("ACCOUNTS_CUD")) return true;
        return false;
      }
      return true;
    },
    parents() {
      if (!this.hasParent || !this.item.parent) return [];
      let parents = [];
      this.accountParentsName(this.item).forEach((parent) => {
        parents.push({
          text: parent,
        });
      });
      // parents.splice(parent.length - 1, 1);
      return parents;
    },
    shenaseMeliRules() {
      return [
        (value) => {
          return value.length == 11 || "شناسه ملی باید یازده رقم باشد";
        },
      ];
    },
    // economicCodeRules() {
    //   return [
    //     (value) => {
    //       return value.length == 12 || "کد اقتصادی باید دوازده رقم باشد";
    //     },
    //   ];
    // },
    canDeleteAccount() {
      return this.item.is_editable && this.canDelete;
    },
  },
  watch: {
    parent() {
      if (!this.item.id) this.item.parent = this.parent;
    },
  },
  created() {
    this.EventBus.$on("get:accounts", () => {
      let parent = this.urlQuery.parent;
      if (parent)
        this.item.parent = this.accounts.filter((o) => o.id == parent)[0];
    });
  },
  mounted() {
    this.getSalePriceTypes();
  },
  methods: {
    getRemainType() {
      let bed = this.item.balance.bed;
      let bes = this.item.balance.bes;
      if (bed == bes) {
        return " - ";
      } else {
        if (bed > bes) {
          return "بدهکار";
        } else {
          return "بستانکار";
        }
      }
    },
    setItem(item) {
      let url = `accounts/accounts/${item.id}`;

      let fetchedItem = this.fetchedItems.find((o) => o.id == item.id);
      if (fetchedItem) {
        this.item = fetchedItem;
        this.setPath(item.path);
      } else {
        this.request({
          url: this.endpoint(url),
          method: "get",
          success: (data) => {
            item = data;
            if (typeof item.parent == typeof 72) {
              item.parent = this.parentItems.filter(
                  (o) => o.id == item.parent
              )[0];
            }
            this.fetchedItems.push(item);
            this.item = item;
            this.isEditing = false;
            this.setPath(item.path);
          },
        });
      }
    },
    setPath(pathId) {
      let path_array = [null, null, null, null, null];
      if (pathId) {
        path_array[4] = pathId;
        let path = this.paths.find((o) => o.id == pathId);
        for (let i = 3; i >= 0; i--) {
          path = this.paths.find((o) => o.id == path.parent);
          path_array[i] = path.id;
        }
      }
      this.path = path_array;
    },
    getItemTemplate() {
      return {
        is_real: true,
        type: null,
        show_in_receive_transaction: false,
        show_in_payment_transaction: false,
        is_editable: true,
      };
    },
    checkFormAndSubmit(item) {
      if (this.accountType == 'p') {
        if (!item.person_type) {
          this.notify('نوع شخص را وارد کنید', 'danger')
        } else {
          if (!item.buyer_or_seller) {
            this.notify('حساب شخص را وارد کنید', 'danger')
          }
          if (item.person_type == 'r') {
            if (!item.name) {
              this.notify('نام کسب و کار را وارد کنید', 'danger')
            } else if (!item.tax_type) {
              this.notify('نوع پرونده مالیاتی را وارد کنید', 'danger')
            }
            // else if (!item.melli_code) {
            //   if (item.tax_type == '3') {
            //     this.notify('کد فراگیر اتباع غیر ایرانی را وارد کنید', 'danger')
            //   } else {
            //     this.notify('کد ملی را وارد کنید', 'danger')
            //   }
            // }
                // else if (!item.eghtesadi_code) {
                //   this.notify('کد اقتصادی را وارد کنید', 'danger')
            // }
            else {
              this.submit(false)
            }

          } else {
            if (!item.name) {
              this.notify('نام کسب و کار را وارد کنید', 'danger')
            } else if (!item.melli_code) {
              this.notify('شناسه ملی را وارد کنید', 'danger')
            } else {
              this.submit(false)
            }
          }
        }
      } else {
        this.submit(false)
      }
    },
    getData() {
      this.getAccounts(true);
      this.getAccountTypes();
      this.getFloatAccountGroups(true);

      this.hasModule("distribution") && this.getPaths();
    },
    getAccount(id) {
      return this.accounts.filter((o) => (o.id = id))[0];
    },
    getSerialized() {
      let item = this.copy(this.item);
      item = this.extractIds(item);
      if (!item.id) item.account_type = this.accountType;
      item.path = this.path["4"];

      item.floatAccountGroups = [];
      this.floatAccountTypes.forEach((floatAccountType) => {
        item.floatAccountGroups.push(item[floatAccountType.ke]);
      });

      return item;
    },

    getPathTitle(level) {
      return getText(PathLevels, level);
    },
    getPathItems(level) {
      return this.paths.filter(
          (o) =>
              o.level == level && (!o.parent || o.parent == this.path[level - 1])
      );
    },
    clearPath(i) {
      for (let j = i + 1; j < 5; j++) {
        this.path[j] = null;
      }
    },
    clearForm() {
      this.isEditing = true;
      this.item = this.getItemTemplate();
      this.setPath();
    },
    NumbersTo16Only(evt) {
      if (this.$refs.cart.$props.value.length >= 16) {
        evt.preventDefault();
      }
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    NumbersTo24Only(evt) {
      if (this.$refs.sheba.$props.value.length >= 24) {
        evt.preventDefault();
      }
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    BankNumbersTo24Only(evt) {
      if (this.$refs.bank_sheba.$props.value.length >= 24) {
        evt.preventDefault();
      }
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
